const NormalLayout = () => import("@/layout/NormalLayout");

const LoginView = () => import("@/views/login/LoginView");
const HomeView = () => import("@/views/home/HomeView");
const PostView = () => import("@/views/post/PostView");

export default [
  {
    path: "/",
    component: NormalLayout,
    redirect: "/",
    children: [
      {
        path: "",
        name: "HomeView",
        component: HomeView,
        meta: {
          usePathKey: true,
          isAuth: false,
          title: "首页",
        },
      },
      {
        path: "login",
        name: "LoginView",
        component: LoginView,
        meta: {
          usePathKey: true,
          isAuth: false,
          title: "登录",
        },
      },
      {
        path: "post/:id",
        name: "PostView",
        component: PostView,
        meta: {
          usePathKey: true,
          isAuth: false,
          title: "帮助中心",
        },
      },
    ],
  },
];
